import React from 'react';

import './_users.scss'
import {Breadcrumb, BreadcrumbItem, Column, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import UsersTable from "../../components/UsersTable";

const Users = () => {
  return (
    <Grid fullWidth className="users-page">
      <Column lg={16} md={8} sm={4} >
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Operatori
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Operatori
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="users-page__r1">
            <Tile>
              <UsersTable />
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default Users